import React, { useContext } from "react";
import { Route, Navigate, useLocation } from "react-router-dom";
import { UserContext } from "../Contexts/UserContext";
import PageForbidden from "../Layouts/403/PageForbidden";

export default function MasterOpsAuthenticatedRoute({ children, ...rest }) {
  const { pathname, search } = useLocation();
  const { user } = useContext(UserContext);

  return user !== null && user.isAuthenticated ? (
    user.userRole === "Master" || user.userRole === "Ops" ? (
      children
    ) : (
      <PageForbidden />
    )
  ) : (
    <Navigate to={`/login?redirect=${pathname}${search}`} />
  );
}
